<template>
    <a-layout id="error_401">
        <a-layout-content class="error_content">
            <a-result
                status="500"
                title="登录失败"
                sub-title="请确认您的企业是否安装机汇管家，前往安装或重新选择企业登录。"
            >
                <template #extra>
                    <a-button type="primary" @click="toInstall">安装机汇管家</a-button>
                    <a-button @click="toJump">重新登录</a-button>
                </template>
            </a-result>
        </a-layout-content>
        <a-layout-footer class="error_footer" v-if="!loading">
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
                浙ICP备14038176号-11
            </a>
        </a-layout-footer>
    </a-layout>
</template>

<script>
import api from '@/apis';
export default {
    data() {
        return {
            defaultUrl: process.env.VUE_APP_DEFAULT,
            loginConfig: {}
        };
    },
    methods: {
        toJump() {
            const redirectUri = encodeURIComponent(`${this.defaultUrl}/login`);
            window.location.href = `https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=${process.env.VUE_APP_LOGIN_APPID}&redirect_uri=${redirectUri}&state=STATE&usertype=${process.env.VUE_APP_USERTYPE}`;
        },
        async toInstall() {
            try {
                const res = await api.postAuthUrl({ url: `${this.defaultUrl}/install` });
                if (res.code !== 0) return;
                const resp = await api.postAuthSession({ code: res.preAuthCode, authType: 1 });
                if (resp.code !== 0) return this.$message.error(`${resp.code}-${resp.msg}`);
                window.location.href = res.url;
            } catch (err) {
                console.log(err);
            }
        }
    }
};
</script>

<style>
#error_401 .error_content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: unset;
    height: calc(100vh - 81px);
    background: #fff;
}
#error_401 .error_footer {
    background: #fff;
    text-align: center;
    padding: 30px;
    z-index: 2;
    position: relative;
}
#error_401 .error_footer a {
    color: #ccc;
}
</style>
